// extracted by mini-css-extract-plugin
export default {"button_submit":"style_button_submit__r6fyL","header":"style_header__pNyJq"};